import { stringify } from "query-string"

import { store } from "@redux"
import { resolveStorageUrl } from "utils"
import { apiInstance } from "./api"

const endpoint = "/image"

export const uploadImage = async (data, imageCategory, onUploadProgress, source = { token: null }) => {
  const { dhFoodsStorage } = apiInstance()

  const response =
    await dhFoodsStorage.post(
      `${endpoint}?imageCategory=${imageCategory}`,
      data,
      {
        cancelToken: source.token,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress
      }
    )

  return response.data.map(image => ({
    ...image,
    url: resolveStorageUrl(image.url)
  }))
}

export const getMedia = async (queries) => {
  const { dhFoodsStorage } = apiInstance()

  const contractId =
    store.getState().systemSettings.contractId

  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await dhFoodsStorage.get(`/stats/stats/${contractId}/list?${query}`)

  return {
    ...response.data,
    storagePath: response.data.url,
    url: response.data.fullUrl || resolveStorageUrl(response.data.url)
  }
}
